import script from "./ParticipantTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantTab.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantTab.vue?vue&type=style&index=0&id=b60862a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b60862a0"]])

export default __exports__